<template>
  <section>
    <nav class="w-full">
      <section class="flex justify-center items-center h-16 lg:justify-start lg:px-4 lg:max-w-5xl lg:mx-auto">
        <router-link to="/" >
          <img src="/image/brand/logo.png" alt="logo page" class="h-8 lg:h-9 w-auto" />
        </router-link>
      </section>
    </nav>
    <section class="diabetesBgHero-1 background-hero py-4 px-4" ref="banner">
      <section class="flex flex-col justify-center py-4 lg:flex-row lg:justify-between lg:px-4 lg:max-w-5xl lg:mx-auto">

          <section class="lg:pr-7 mb-4 lg:mb-0 flex-1">
            <p class="text-white text-2xl lg:text-3xl font-bold" v-text="'Telemedicina y Diabetes 2022'" />
       
            <p class="text-white mt-4 text-justify">
              La Telemedicina ha avanzado a pasos agigantados en los últimos meses, y aunque todas las áreas y servicios de salud pueden apalancarse de la salud digital para ayudar más y mejor a sus pacientes, son aquellos portadores de condiciones crónicas de salud, que por consiguiente ameritan seguimiento y control a largo plazo, han sido un grupo de especial atención y beneficio de su salud y calidad de vida, gracias al uso de la telemedicina.
            </p>
            <p class="text-white mt-2 text-justify">
              Por esto, hemos organizado <b>DIABETES Y TECNOLOGÍA: Juntas para optimizar el buen control</b>, un webinar exclusivo donde mostraremos las potencialidades de la Telemedicina en una condición tan común y desafiante como es la diabetes. Esto será el dia 31 de Enero a las 8 pm hora Ecuador/Perú/Colombia.
            </p>
          </section>
          <section class="bg-white rounded-md py-4 px-4 flex-1">
            <p class="text-lg font-bold text-center mb-4" v-text="'Reserva tu cupo a este gran evento gratuito'" />
            <text-field v-model="form.name" identity="name" placeholder="Nombre*" class="mt-3" />
            <p v-if="nameError" class="text-red-600 error-text">{{ nameError }}</p>
            <text-field v-model="form.last_name" identity="last_name" placeholder="Apellido*" class="mt-3" />
            <p v-if="lastNameError" class="text-red-600 error-text">{{ lastNameError }}</p>
            <text-field v-model="form.email" identity="email" placeholder="Correo Electronico*" class="mt-3" />
            <p v-if="emailError" class="text-red-600 error-text">{{ emailError }}</p>
            <vue-phone-number-input
              class="mt-3 mb-2"
              :default-country-code="defaultCountry"
              :only-countries="countriesList"
              :translations="translations"
              @update="onUpdate"
              v-model="form.phone"
            />
            <p v-if="phoneError" class="text-red-600 error-text">{{ phoneError }}</p>
            <section class="flex justify-center mt-4">
              <check-field v-model="form.terms" identity="terms" label="Acepto los terminos y condiciones" />
            </section>
            <p v-if="termsError" class="text-red-600 error-text text-center">{{ termsError }}</p>
            
            

            <section class="flex justify-center">
              <g-recaptcha
                  class="mt-3"
                  :data-sitekey="sitekey"
                  :data-validate="validate"
                  :data-callback="callback"
                  data-btn-class="py-2 px-5 bg-skin-fcce font-bold text-black text-sm rounded-md mx-auto focus:outline-none text-center mt-2 flex"
                  data-language="es-419"
                  data-size
              >Enviar
              </g-recaptcha>


              <!--<button
                class="py-2 px-5 bg-skin-fcce font-bold text-black text-sm rounded-md mx-auto focus:outline-none"
                v-text="'Enviar'"
              />-->
            </section>
            <section>
              <p v-if="captchaError" class="text-red-600 error-text text-center mt-3">{{ captchaError }}</p>
            </section>
          </section>

      </section>
    </section>

    <section class="w-full flex flex-col items-start justify-center lg:pt-4 lg:flex-row lg:justify-between lg:px-4 lg:max-w-5xl lg:mx-auto mt-5 lg:mt-4 lg:mb-7">
      <p class="text-center middle-text-box font-light">
        En el caso de la diabetes, una condición que afecta a más de 62 millones de personas en las Américas, es una estrategia de gran ayuda, ya que ha demostrado científicamente, trabajar de manera efectiva en mejorar puntos duros que son de gran importancia para estos pacientes, dentro de los cuales destacan:
      </p>
    </section>

    <section-content v-for="(content, index) in contentSections" :key="index" :info="content" />
   
    <section class="bg-blue-700 py-6 flex flex-col justify-center mx-auto diabetesBgHero-2">
      <p
        class="text-white font-bold text-center text-lg"
        v-text="'Por esto te invitamos a participar de este webinar'"
      />
      <section class="md:flex md:items-center md:justify-center">
      <p
        class="text-white font-bold text-center text-lg md:mr-1"
        v-text="'GRATUITO e interactivo,'"
      />
<p
        class="text-white font-bold text-center text-lg"
        v-text="'DIABETES Y TECNOLOGÍA:'"
      />
      </section>
      <p class="text-white font-bold text-center text-lg">
        Juntas para optimizar el buen control
      </p>
      
      <p
        class="text-white middle-text-box text-center mx-auto mt-4 max-wdith-text"
        v-text="
          'El cual será Dictado por la Dra Omidres Pérez, Medico Especilista en Medicina Interna, Endocrinología y Metabolismo, Autora de libro Controlando la diabetes a un click, Directora del Diplomado Internacional de Telemedicina , y donde te aprenderás las estrategias que toda consulta de telemedicina en diabetes debe cumplir para lograr esos resultados esperados.'
        "
      />

      <p
        class="text-white font-bold text-center text-lg mt-3"
        v-text="'Esto será el dia 31 de Enero a las '"
      />
      <p
        class="text-white font-bold text-center text-lg"
        v-text="'8 pm (Hora Ecuador/Perú) 7 pm (Hora México)'"
      />

      <section class="flex justify-center mt-4">
        <button
          class="py-2 px-5 bg-skin-fcce font-bold text-black text-sm rounded-md mx-auto focus:outline-none"
          v-text="'Registrarse'"
          @click="scrollToBanner"
        />
      </section>
    </section>
    <footer class="flex justify-center bg-gray-600 py-2">
      <p class="text-white text-sm" v-text="'Amoba Software todos los derechos reservados 2022'" />
    </footer>
  </section>
</template>
<script>
import TextField from "./TextField.vue";
import VuePhoneNumberInput from "vue-phone-number-input";
import CheckField from "./CheckField.vue";
import SectionContent from "./SectionContent.vue";
import gRecaptcha from '@finpo/vue2-recaptcha-invisible';
import axios from "axios";
export default {
  name: "Landing",
  components: { TextField, VuePhoneNumberInput, CheckField, SectionContent, gRecaptcha, },
  metaInfo: {
      title: 'DIABETES Y TECNOLOGÍA: Juntas para optimizar el buen control',
      titleTemplate: '%s - Dra. Omidres Pérez',
      content: 'DIABETES Y TECNOLOGÍA: Juntas para optimizar el buen control',
      meta: [
          { name: 'DIABETES Y TECNOLOGÍA: Juntas para optimizar el buen control',
              content: 'Hagamos viral la salud con la Dra. Omidres Pérez',
              vmid: 'Dra Omidres Pérez' }
      ],
      htmlAttrs: {
          lang: 'es',
          amp: true,
      }
  },
  data: () => ({
    rexEmail: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    sitekey:process.env.VUE_APP_RECAPTCHA,
    form: {
      name: null,
      last_name: null,
      email: null,
      phone: null,
      phoneFormatted: null,
      terms: false,
      
    },
    contentSections: [
      {
        title: "",
        description:
          "<li style='margin-top: 10px'>Disminuir los niveles de Hemoglobina glicosilada (HbA1c) sin riesgos.</li> <li style='margin-top: 10px'>Aumentar adherencia al tratamiento.</li> <li style='margin-top: 10px'>Optimizar el monitoreo de los parámetros metabólicos dinámicos y la toma de decisiones.</li> <li style='margin-top: 10px'>Acceso efectivo a la educación diabetológica.</li> <li style='margin-top: 10px'>Prevenir complicaciones y secuelas de la diabetes</li>",
        image: "image/courses/diabetesTelemedicina/foto_1.webp",
        side: "right",
      },
      {
        title: "",
        description:
          "Para lograrlo, el equipo de salud y los pacientes deben estar en sintonía, y es el profesional de salud de vanguardia, innovador y comprometido con sus pacientes presentes y futuros, el encargado de liderar esta transformación digital en aras del buen control, logran un consultorio sin fronteras, efectivo y eficaz, de manera ética, legal, segura y accesible a muchos.",
        image: "image/courses/diabetesTelemedicina/foto_2.webp",
        side: "left",
      },
    ],
    
    defaultCountry: "EC",
    translations: {
      countrySelectorLabel: "Código",
      countrySelectorError: "Pais",
      phoneNumberLabel: "Número de teléfono",
      example: "Ejemplo:",
    },
    nameError:"",
    lastNameError:"",
    emailError:"",
    phoneError:"",
    termsError:"",
    captchaError:""
  }),
  methods: {
    
    onUpdate(payload) {
      this.phoneFormatted = payload.formatInternational;
    },
    scrollToBanner() {
      this.$refs.banner.scrollIntoView({ behavior: "smooth" });
    },
    validate() {

      this.nameError = ""
      this.lastNameError = ""
      this.emailError = ""
      this.phoneError = ""
      this.termsError = ""
      this.captchaError = ""

      let error = true
      if(this.form.name == "" || this.form.name == null){
        this.nameError = "Nombre es requerido"
        error = false
      }

      if(this.form.last_name == "" || this.form.last_name == null){
        this.lastNameError = "Apellido es requerido"
        error = false
      }

      
      if(this.form.email == "" || this.form.email == null){
        this.emailError = "Email es requerido"
        error = false
      }else{

        if(!this.rexEmail.test(String(this.form.email).toLowerCase())){
          this.emailError = "Email no tiene un formato válido"
          error = false
        }

      }

      if(this.form.phone == ""  || this.form.phone == null){
        this.phoneError = "Teléfono es requerido"
        error = false
      }

      if(this.form.terms == false){
        this.termsError = "Debes aceptar los terminos y condiciones"
        error = false
      }

      return error

    },
    callback(token) {
      this.termsError = ""
        if (token) 
            this.signUp();

        else{
          this.captchaError = "No has validado el captcha"
        }
    },
    async signUp(){

      var url = '/api/v2/leads';

      const response = await axios.post(url, {
          name: this.form.name,
          last_name: this.form.last_name,
          email: this.form.email,
          movil: this.form.phone,

          title: 'DIABETES Y TECNOLOGÍA: Juntas para optimizar el buen control',
          message: "diabetes telemedicina",
          code_relation: "TELEMEDICINA,DIABETES",
          proyect_id: process.env.VUE_APP_PROYECT_ID,
          ip: this.ip,
          town : this.town,
          country: this.country,
          body:{
            "hora": "LUNES 31 DE ENERO DE 2022 - 08:00 PM EC-PE - 07:00 PM MX",
            "enlace": "https://us06web.zoom.us/j/82774675137",
            "reunion_id": "827 7467 5137"
          },
      })

      if(response.data.success == true){

        sessionStorage.setItem("lead_thanks", "true")
        this.$router.push({ name: "diabetesTelemedicineThanks" });
        

      }

    },
    async getIpAddress(){

      
        let url = "https://ipapi.co/json/";
        const response = await axios.get(url)
        this.ip = response.data.ip
        this.town = response.data.city
        this.country = response.data.country_name

      
    } 
  },
  mounted(){
    this.getIpAddress()
  }

}
</script>

<style scoped>

  .diabetesBgHero-1{
    background-image: url("/image/courses/diabetesTelemedicina/fondo_banner (1).webp");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
  }

  .diabetesBgHero-2{
    background-image: url("/image/courses/diabetesTelemedicina/Fondo secundario.webp");
    background-size: cover;
    background-position: center center;
  }

  .error-text{
    margin-top: -5px;
    font-size: 10px;
  }

  .middle-text-box{
    padding-left: 20%;
    padding-right: 20%;
  }

  .diabetes-list{
    margin-top: 10px;
  }

  .max-wdith-text{
    max-width: 1600px;
  }

  @media (max-width: 991px){

    .diabetesBgHero-2{
        margin-top: 50px;
    }
  }

</style>
